import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=6225eb4e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=6225eb4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6225eb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6225eb4e')) {
      api.createRecord('6225eb4e', component.options)
    } else {
      api.reload('6225eb4e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=6225eb4e&scoped=true&", function () {
      api.rerender('6225eb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24d3Wi1Kovvmu/JS/comp/PopupDialog.vue"
export default component.exports